<template>
	<div class="fi-row">
		<span class="fi-rowIcon"><sym-icon name="checkmark-circle-18"></sym-icon></span>
		<div class="fi-row-message">
			<span class="forceinfoHighlighted"><span v-if="fi.entered">{{ format(parseDate(fi.entered), env) }}</span> {{ enteredBy }} {{ env.msg('forceInfo.userCompleted') }}</span>

			<span v-if="fi.srcType === SrcType.TASK">{{ env.msg('forceInfo.dTask') }}:</span>
			<span v-else-if="fi.srcType === SrcType.EVENT">{{ env.msg('forceInfo.dEvent') }}:</span>
			<span v-else-if="fi.srcType === SrcType.CONTACT">{{ env.msg('forceInfo.dContact') }}:</span>
			<span v-else-if="fi.srcType === SrcType.OPPORTUNITY">{{ env.msg('forceInfo.dOpportunity') }}:</span>
			<span v-else-if="fi.srcType === SrcType.BUSCASE">{{ env.msg('forceInfo.dBusCase') }}:</span>

			<object-link :src-id="fi.srcId" :src-type="fi.srcType">{{ fi.srcName }}</object-link>
			<a v-if="isMe" href="#" class="fbutton" @click.prevent="deleteFi">{{ env.msg('butt.ok') }}</a>
			<fi-date :value="fi.entered"></fi-date>
		</div>
	</div>

</template>

<script setup lang="ts">
import {computed} from "vue";
import {ForceInfo} from "@t/processes/ForceInfo.ts";
import {injectEnv} from "@fd/Environment.ts";
import FiDate from "@/processes/FiDate.vue";
import SymIcon from "@fd/helpers/SymIcon.vue";
import {SrcType} from "@t/meta/SourceType.ts";
import ObjectLink from "@fd/helpers/ObjectLink.vue";
import {useForceInfoStore} from "@/store/ForceInfoStore";
import {parseDate, format} from "@t/util/DateUtil.ts";

const props = defineProps<{
	fi: ForceInfo,
	enteredBy: string
}>();
const env = injectEnv();
const fis = useForceInfoStore();

const isMe = computed<boolean>(() => {
	return env.user && props.fi.responsible === env.user.login;
});

function deleteFi() {
	fis.deleteForceInfo(props.fi.id);
}

</script>

<style>

</style>